'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.saveLogNavigation = saveLogNavigation;
exports.saveContactUsSource = saveContactUsSource;
exports.logConnectionMethod = logConnectionMethod;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG_NAVIGATION = 'redux/log/LOG_NAVIGATION';
var LOG_CONTACT_US_SOURCE = 'redux/log/LOG_CONTACT_US_SOURCE';
var LOG_CONNECTION_METHOD = 'redux/log/LOG_CONNECTION_METHOD';

var initialState = {
  contactUsSrc: '',
  src: '',
  srcTime: new Date().getTime(),
  connectionMethod: ''
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOG_NAVIGATION:
      return (0, _extends3.default)({}, state, {
        src: action.destinationPathName,
        srcTime: action.destinationTime
      });
    case LOG_CONTACT_US_SOURCE:
      return (0, _extends3.default)({}, state, {
        contactUsSrc: action.contactUsSrc
      });
    case LOG_CONNECTION_METHOD:
      return (0, _extends3.default)({}, state, {
        connectionMethod: action.connectionMethod
      });
    default:
      return state;
  }
}

function saveLogNavigation(destinationPathName, destinationTime, store) {
  if (store) {
    return store.dispatch({ type: LOG_NAVIGATION, destinationPathName: destinationPathName, destinationTime: destinationTime });
  }
  return { type: LOG_NAVIGATION, destinationPathName: destinationPathName, destinationTime: destinationTime };
}

function saveContactUsSource(contactUsSrc, store) {
  if (store) {
    return store.dispatch({ type: LOG_CONTACT_US_SOURCE, contactUsSrc: contactUsSrc });
  }
  return { type: LOG_CONTACT_US_SOURCE, contactUsSrc: contactUsSrc };
}

function logConnectionMethod(connectionMethod, store) {
  if (store) {
    return store.dispatch({ type: LOG_CONNECTION_METHOD, connectionMethod: connectionMethod });
  }
  return { type: LOG_CONNECTION_METHOD, connectionMethod: connectionMethod };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/log.js
// module id = 168
// module chunks = 0